import React, { useState, useEffect } from "react"

import CustomSpin from "../../../v2-components/Antd/Spin"
import CustomAlert from "../../../v2-components/Antd/Alert"

import UserForm from "../components/UserForm"
import { useUserService } from "../hooks/useUserService"
import "../styles/common.css"

const MyUserForm = () => {
    const [userData, setUserData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const { fetchCurrentUser, updateCurrentUser, changePassword } = useUserService()

    // Cargar datos del usuario al montar el componente
    useEffect(() => {
        let isMounted = true

        const loadUserData = async () => {
            try {
                setLoading(true)
                const data = await fetchCurrentUser()

                if (isMounted && data) {
                    setUserData(data)
                    setError(null)
                }
            } catch (err) {
                if (isMounted) {
                    setError("No se pudieron cargar los datos del usuario")
                    console.error(err)
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        loadUserData()

        return () => {
            isMounted = false
        }
    }, [fetchCurrentUser])

    // Manejar actualización de datos
    const handleUpdate = async (updatedData) => {
        try {
            setLoading(true)
            const { old_password, new_password, ...userData } = updatedData

            const result = await updateCurrentUser(userData)

            if (new_password) {
                await changePassword(old_password, new_password)
            }

            if (result) {
                setUserData(result)
            }
        } catch (err) {
            setError("Error al actualizar los datos")
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    if (loading && !userData) {
        return (
            <div className="loading-container">
                <CustomSpin size="large" tip="Cargando datos del usuario..." />
            </div>
        )
    }

    if (error) {
        return <CustomAlert message={error} type="error" />
    }

    return <div>{userData && <UserForm values={userData} onFinish={handleUpdate} loading={loading} />}</div>
}

export default React.memo(MyUserForm)

